import { KeyLost } from './keyLost/KeyLost';
import styles from './styles.module.scss';

export const KeyLostPage = () => {
  return (
    <div className={styles.keyLostPage}>
      <KeyLost />
    </div>
  );
};
